let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kE76g")]).then(() => parcelRequire('6Ya0u'));